import { isPresent } from "@whilecat/core/utils/objects.js";

export const StatisticsEventType = {
    TASK_FAILED: "TASK_FAILED",
} as const;

export async function collectEvent(eventType: string, payload: any) {
    // @ts-ignore
    if (isPresent(umami)) {
        // @ts-ignore
        umami.track(eventType, payload);
    }
}
